module.exports = __webpack_public_path__ + "6fcb2e22a641b96fb6bbce27740a923b.svg";